import { FormControlLabel, Grid, Radio, RadioGroup } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import empresaApi from 'app/services/api/empresaApi';
import { getEmpresaContexto } from 'app/utils/geralUtil';
import { useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';
import { ContasPagarCodigoBarras, ContasPagarParcelada, ContasPagarUnica } from '../../components';
import { ContasPagarAction, useContasPagar } from '../../store';
import { initContasPagar } from '../../store/contasPagarAction';

const useStyles = makeStyles(() => ({
  firstRadioOption: {
    paddingLeft: '1%',
  },
  lastRadioOption: {
    paddingRight: '1%',
  },
}));

const ContasPagarAbaDadosDespesa = ({ isEdicao, origemCompra }) => {
  const formikContext = useFormikContext();
  const [, dispatch] = useContasPagar();
  const { values, handleChange, handleBlur, errors, touched, submitCount, setErrors } = formikContext;
  const classes = useStyles();

  const [empresaIbsCbs, setEmpresaIbsCbs] = useState(false);

  const handleTipoDespesa = (event) => {
    setErrors({});
    dispatch(ContasPagarAction.cadastrar({ ...initContasPagar, tipoDespesa: event.target.value }));
  };

  useEffect(() => {
    const carregarEmpresaIbsCbs = async () => {
      try {
        const empresaId = getEmpresaContexto();
        const empresa = await empresaApi.buscar(empresaId);
        if (empresa?.data?.ibsCbs) {
          setEmpresaIbsCbs(true);
        }
      } catch (error) {
        setEmpresaIbsCbs(false);
      }
    };
    carregarEmpresaIbsCbs();
  }, []);

  return (
    <>
      <Grid container justify="center">
        <Grid item xs={12}>
          <RadioGroup
            row
            aria-label="position"
            id="tipoDespesa"
            name="tipoDespesa"
            value={values?.tipoDespesa}
            onChange={handleTipoDespesa}
            defaultValue="UNICA"
          >
            <Grid container justify="space-between">
              <FormControlLabel
                value="UNICA"
                control={<Radio color="primary" />}
                label="Despesa única"
                className={classes.firstRadioOption}
                disabled={isEdicao} // RNE-148
              />

              <FormControlLabel
                value="PARCELADA"
                control={<Radio color="primary" />}
                label="Despesa parcelada"
                disabled={isEdicao} // RNE-148
              />

              <FormControlLabel
                value="LINHA_DIGITAVEL"
                control={<Radio color="primary" />}
                label="Despesa com código de barras"
                className={classes.lastRadioOption}
                disabled={isEdicao} // RNE-148
              />
            </Grid>
          </RadioGroup>
        </Grid>
      </Grid>
      {values?.tipoDespesa === 'UNICA' && (
        <ContasPagarUnica
          handleChange={handleChange}
          handleBlur={handleBlur}
          errors={errors}
          touched={touched}
          values={values}
          isEdicao={isEdicao}
          origemCompra={origemCompra}
          empresaIbsCbs={empresaIbsCbs}
        />
      )}
      {values?.tipoDespesa === 'PARCELADA' && (
        <ContasPagarParcelada
          handleChange={handleChange}
          handleBlur={handleBlur}
          errors={errors}
          touched={touched}
          values={values}
          submitCount={submitCount}
          origemCompra={origemCompra}
          empresaIbsCbs={empresaIbsCbs}
        />
      )}
      {values?.tipoDespesa === 'LINHA_DIGITAVEL' && (
        <ContasPagarCodigoBarras
          handleChange={handleChange}
          handleBlur={handleBlur}
          errors={errors}
          touched={touched}
          values={values}
          origemCompra={origemCompra}
          empresaIbsCbs={empresaIbsCbs}
        />
      )}
    </>
  );
};

export default ContasPagarAbaDadosDespesa;
